"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noWait = void 0;
async function noWait() {
    return new Promise((resolve) => {
        if (typeof setImmediate === 'function') {
            setImmediate(() => resolve());
        }
        else {
            // didn't find a better way to do it in the browser
            setTimeout(() => resolve(), 0);
        }
    });
}
exports.noWait = noWait;
//# sourceMappingURL=noWait.js.map